<ng-template #tcpaConsent>
  <ng-container *transloco="let t">
  <div class="d-flex flex-column flex-column-fluid p-10 pb-lg-10 login-wrapper">
    <div class="w-md-600px bg-white rounded shadow-sm p-7 p-lg-10 login-body">
      <div class="d-flex justify-content-between align-items-start mb-4">
        <div class="flex-grow-1 d-flex justify-content-center">
          <logo [logoUrlsToTry]="possibleLogoUrls"></logo>
        </div>
        <language-switcher *ngIf="anonymousPortalSettings.languageToggleEnabled$ | async"
                           [notice]="anonymousPortalSettings.languageToggleNotice$ | async"></language-switcher>
      </div>

      <div class="text-center my-4">
        <h2 class="text-dark mb-3">{{ t('tcpaConsentLink.title') }}</h2>
      </div>

      @switch (status) {
        @case ('Loading') {
          <div class="d-flex justify-content-center my-10">
            <span class="spinner-border text-primary" role="status"></span>
          </div>
        }
        @case ('Available') {
          <div class="text-gray-700 fs-6 mb-6">
            {{ t('tcpaConsentLink.intro', { lastFour: link?.phoneLastFour }) }}
          </div>
          <div id="tcpaConsentLinkText" class="border rounded p-5 mb-6 fs-6" [innerHtml]="consentText"></div>
          <label class="form-check form-check-solid mb-6">
            <input class="form-check-input" type="checkbox" name="tcpaConsentLinkAgreed" [(ngModel)]="agreed" [disabled]="isRefreshing || isSubmitting" />
            <span class="fw-bold ps-2 fs-6">{{ t('tcpaConsentLink.agree') }}</span>
          </label>
          @if (consentChanged) {
            <div class="alert alert-warning p-4 mb-5">{{ t('tcpaConsentLink.consentChanged') }}</div>
          }
          @if (submitFailed) {
            <div class="alert alert-danger p-4 mb-5">{{ t('tcpaConsentLink.submitFailed') }}</div>
          }
          <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-primary" [disabled]="!agreed || isSubmitting || isRefreshing" (click)="onSubmitClicked()">
              @if (isSubmitting) {
                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              }
              {{ t('tcpaConsentLink.submit') }}
            </button>
          </div>
        }
        @case ('AlreadyConsented') {
          <div class="alert alert-success p-5 mb-5 text-center">{{ t('tcpaConsentLink.thankYou') }}</div>
        }
        @case ('Expired') {
          <div class="alert alert-warning p-5 mb-5 text-center">{{ t('tcpaConsentLink.expired') }}</div>
        }
        @default {
          <div class="alert alert-warning p-5 mb-5 text-center">{{ t('tcpaConsentLink.unavailable') }}</div>
        }
      }
    </div>
  </div>
  </ng-container>
</ng-template>

<user-account-template [contentTemplate]="tcpaConsent"></user-account-template>
